import { render, staticRenderFns } from "./mbwhatsapp.vue?vue&type=template&id=f718cdec&scoped=true"
import script from "./mbwhatsapp.vue?vue&type=script&lang=js"
export * from "./mbwhatsapp.vue?vue&type=script&lang=js"
import style0 from "./mbwhatsapp.vue?vue&type=style&index=0&id=f718cdec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f718cdec",
  null
  
)

export default component.exports